import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { isMock } from '../utilities/is-mock';

type OtherScheduleCycleRequest = {
    id: string;
    filter: string;
    sort: string;
};

type GetOtherScheduleResponse = {
    prev?: { id: string; name: string };
    next?: { id: string; name: string };
};

async function getOtherScheduleCycle(
    workpaperId: string,
    { id, filter, sort }: OtherScheduleCycleRequest
): Promise<GetOtherScheduleResponse> {
    const query = isMock() ? `?filter=${filter}&sort=${sort}` : `?${filter}&${sort}`;
    const { data } = await api.get(`/workpapers/${workpaperId}/other-schedules/${id}/cycle${query}`);
    return data;
}

export function useOtherScheduleCycle(
    { id, filter, sort }: OtherScheduleCycleRequest,
    enabled = true
): UseQueryResult<GetOtherScheduleResponse, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useQuery(['other-schedules', id, 'cycle', filter, sort], () => getOtherScheduleCycle(workpaperId, { id, filter, sort }), {
        enabled,
    });
}
